/**
 * The desktop profile's tab band.
 *
 * It locks flush to the top of the viewport and stays there for the whole
 * page, carrying the profile's tabs and its two contact routes with the
 * reader. The brand badge that used to lock beside it now straddles the
 * banner's edge with the other detail pages' badges and stays on the page.
 *
 * All values are design px at the 1920 frame, in rem so they scale with the
 * vw-anchored root font-size.
 */

/** The tab band: 92px tall, locked flush to the top of the viewport. */
export const RAIL_TABS_BAND = 'md:h-[5.75rem]';
export const RAIL_TABS_TOP = 'md:top-0';
